"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Badge = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Badge = ({
  className,
  content,
  variant,
  customColors,
  style,
  enforceCharacterLimit,
  ...rest
}) => {
  let baseClass = "sp-badge";
  let badgeStyles = {
    backgroundColor: customColors === null || customColors === void 0 ? void 0 : customColors.backgroundColor,
    color: customColors === null || customColors === void 0 ? void 0 : customColors.textColor,
    ...style
  };
  let classes = (0, _classnames.default)(className, `${baseClass}`, variant && `${baseClass}--${variant}`);

  let formattedContent = (variant, content) => {
    let newContent = content;
    let stringOfContent = content.toString();

    if (stringOfContent.length > 3 && enforceCharacterLimit) {
      newContent = stringOfContent.substr(0, 3);
    }

    switch (variant) {
      case "added":
        return `+${newContent}`;

      case "removal":
        return `-${newContent}`;

      default:
        return newContent;
    }
  };

  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: classes
  }, rest, {
    style: badgeStyles
  }), formattedContent(variant, content));
};

exports.Badge = Badge;
Badge.defaultProps = {
  variant: "primary",
  enforceCharacterLimit: true
};
Badge.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  customColors: _propTypes.default.object,
  enforceCharacterLimit: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(_utils.enums.badgesVariants),
  content: _propTypes.default.number.isRequired
};
var _default = Badge;
exports.default = _default;